<div class="x-row">
  <button mat-icon-button (click)="closePreview()" *ngIf="!forAssistant">
    <svg-icon src="assets/svg/x.svg" viewbox="auto" svgClass="grey"></svg-icon>
  </button>
</div>
<div class="content">

  <div class="content-box">

    <div class="container-row">
      <lhpe-select
        [control]="templateControl"
        placeholder="Template"
        [options]="templateOptions"
        displayValue="name"
        [optionIsSelf]="true"
        [required]="true"
      >
      </lhpe-select>
    </div>

    <div class="container-row">
      <lhpe-input
        [control]="headlineControl"
        placeholder="Push notification and content headline"
        [required]="true"
      >
      </lhpe-input>
    </div>

    <div class="container-row">
      <lhpe-textarea
        [control]="notificationControl"
        placeholder="Push notification text"
        [required]="true"
        [rows]="3"
      >
      </lhpe-textarea>
    </div>

    <div class="container-row editor">
      <editor apiKey="ck8ze3gv5uipup94hehaevo1z6p1h9eh4wzi0h86qad6xam6" [init]="{plugins: 'link', menubar: false, statusbar: false, height: '300px', width: '100%'}" [(ngModel)]="contentControlModel" (ngModelChange)="bodyContentChanged($event)" ></editor>
      <!--
      <lhpe-textarea
        [control]="contentControl"
        placeholder="Body content"
        [required]="true"
        [rows]="5"
      >
      </lhpe-textarea>
      -->
    </div>

    <div class="redemptions-feedback">
      <div class="redemptions-feedback-heading">Redemptions and feedback</div>
      <div class="options">
        <div class="redemption">
          Redemption code
          <mat-slide-toggle
            color="lightGreen"
            [formControl]="redemptionControl"
            [checked]="redemptionControl.value"
          >
            {{ redemptionControl.value ? "Enabled" : "Disabled" }}
          </mat-slide-toggle>
        </div>
        <div class="feedback">
          Thumbs up/down input
          <mat-slide-toggle
            color="lightGreen"
            [formControl]="feedbackControl"
            [checked]="feedbackControl.value"
          >
            {{ feedbackControl.value ? "Enabled" : "Disabled" }}
          </mat-slide-toggle>
        </div>
      </div>
    </div>

    <div class="assistant" *ngIf="forAssistant">
      <button mat-button color="lightGreen" (click)="closePreview(true)">
        Accept
      </button>
      <button mat-button color="warn" (click)="closePreview(false)">
        Reject
      </button>
    </div>

  </div>

  <div
    class="mobile-push-preview"
    *ngIf="type === 'mobilePush'"
    lhpeElementLoader
    #elementLoader="elementloader"
  >
    <div class="phone">
      <div *ngIf="pushNotificationSelected" class="push-notification">
        <div class="notification">
          <div class="header">
            <div class="icon"></div>
            <div class="app-name">
              {{ currentApp ? currentApp.name : "YOUR APP NAME HERE" }}
            </div>
            <div class="time">now</div>
          </div>
          <div class="body">
            <div class="heading">{{ heading ? heading : "undefined" }}</div>
            <div class="message">{{ text ? text : "undefined" }}</div>
            <div class="press-for-more">Press for more</div>
          </div>
        </div>
      </div>
      <div *ngIf="contentSelected" class="preview" [innerHTML]="content"></div>
      <div class="signal-phone"></div>
    </div>
    <div class="options">
      <button
        mat-button
        color="fiord"
        [disabled]="pushNotificationSelected"
        (click)="onPushSelected()"
      >
        Push notification
      </button>
      <button
        mat-button
        color="fiord"
        [disabled]="contentSelected"
        (click)="onContentSelected()"
      >
        Content
      </button>
    </div>
  </div>
</div>
